export default __webpack_public_path__ + "009f6234f490974766217d1cbcc3df52.svg";